import { DataBean } from "../DataBean";

export class FixedAssetItemDeterioration extends DataBean {


    public async getFixedAssetItemDeteriorationCatalog(idItem:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetItemDeteriorationCatalog_Number", [idItem]);
    }
    
}